<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Message.ViewChargebackFile')"
    width="630px"
    :close-on-click-modal="false"
    :class="'app-main-inner'+(uploading?' not-click':'')"
  >
    <div class="app-main-inner-row row-grid" style="min-height:350px;padding:0">
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width:100%"
        @gridReady="params=>gridApi=params.api"
      />
    </div>

  </el-dialog>
</template>

<script>

import { AutoIncrementNum, DocumentManage } from '@/utils/commonUtil'
import { cacheName, cache } from '@/utils/cacheManager'
import { getDocCategoryTypeTreeByLob } from '@/api/sysManage/baseConfig/docCategory'
import ColumnUtils from '@/utils/ColumnUtils'
import URL from '@/api/urlTranslator'

export default {
  name: 'CustomsInfoFile',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    category: { type: String },
    lob: { type: String, default: '' },
    model: { type: Object }
  },
  data() {
    return {
      innerVisible: false,
      user: {},
      storageURL: '',
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('FileHistory.fileName'),
          field: 'fileName',
          suppressMenu: true,
          width: 175,
          cellRenderer: params => {
            if (params.data.documentId) {
              return `<a href="${URL.common.findByFileId}/${
                params.data.documentId
              }?sessionId=${
                this.user.sessionId
              }" target="_blank" style="color:#46a6ff">${params.value}</a>`
            } else {
              return params.value
            }
          }
        },
        {
          headerName: this.$t('FileHistory.jobType'),
          field: 'fileType',
          suppressMenu: true,
          width: 90
        },
        {
          headerName: this.$t('FileHistory.fileSize'),
          field: 'fileSize',
          suppressMenu: true,
          width: 90,
          cellRenderer: params => {
            return params.value ? (params.value / 1024).toFixed(1) + 'KB' : ''
          }
        },
        {
          headerName: this.$t('Partners.UploadTime'),
          field: 'dateCreated',
          suppressMenu: true,
          width: 90,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('SeaExport.UploadProgress'),
          field: 'fileId',
          suppressMenu: true,
          width: 90,
          cellRenderer: params => {
            if (params.value) {
              return `<span style="color:#67C23A">${this.$t('Message.Uploaded')}</span>`
            }
            if (this.uploading) {
              return this.$t('queryJob.uploading') + '...'
            }
            return this.$t('Message.Waiting')
          }
        }
      ],
      rowData: [],
      gridApi: null,
      autoIncrementNum: new AutoIncrementNum(),
      documentManage: new DocumentManage(),
      docTypeTree: {
        visible: false,
        gridOptions: {
          rowSelection: 'single',
          groupDefaultExpanded: 0,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: data => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('SeaExport.DocumentType'),
            width: 320,
            suppressMenu: true,
            cellRendererParams: {
              suppressDoubleClickExpand: true,
              innerRenderer: params => {
                if (params.data.type === 2) {
                  const iconName = params.data.checked
                    ? 'checkbox-checked'
                    : 'checkbox-notChecked'
                  return `<svg class="svg-icon" aria-hidden="true" style="height:1.2em;width:1.2em;vertical-align:text-bottom;">
                            <use xlink:href="#icon-${iconName}"></use>
                          </svg>
                          &nbsp;${params.data.chineseName}`
                }
                return params.data.chineseName
              }
            },
            onCellClicked: params => {
              if (params.data.type === 2) {
                const checked = !params.data.checked
                if (checked) {
                  this.docTypeTree.rowData.forEach(item => {
                    item.checked = false
                  })
                }
                params.data.checked = checked
                params.api.refreshCells({ force: true })
              }
            }
          },
          columnDefs: [],
          context: {
            componentParent: this
          }
        },
        rowData: [],
        gridApi: null
      },
      docTypeMap: new Map(),
      uploading: false
    }
  },
  computed: {
    finalLob() {
      return this.lob // || this.job.lob
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.initData()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
        this.$emit('uploadDone')
      }
      this.$emit('update:visible', newVal)
    },
    finalLob(newVal) {
      this.buildDocTypeTree()
    }
  },
  async created() {
    await this.buildDocTypeTree()
    if (this.visible) {
      this.innerVisible = true
      await this.initData()
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('showDocTypeTree', function(seq) {
      context.showDocTypeTree(seq)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    async initData() {
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.user = cache.user
      this.storageURL = cache.config.get('StorageURL')
      if (this.model) {
        this.rowData = Array.from(this.model.businessDocuments, p => {
          return {
            fileName: p.fileName,
            fileType: p.fileType || '',
            fileSize: p.fileSize,
            dateCreated: p.dateCreated,
            documentId: p.documentId
          }
        })
      }
      // await this.toQuery()
    },
    async buildDocTypeTree() {
      if (this.finalLob) {
        getDocCategoryTypeTreeByLob({
          constructLobParent: false,
          lob: this.finalLob
        }).then(res => {
          const data = res.data.filter(p => {
            const pathArr = p.path.split(',')
            if (p.type === 1) {
              return pathArr.length === 1
            }
            if (p.type === 2) {
              return pathArr.length > 1
            }
            return false
          })
          data.forEach(item => {
            item.checked = false
            if (item.type === 2) {
              this.docTypeMap.set(item.code.toUpperCase(), item.chineseName)
            }
          })
          this.docTypeTree.rowData = data
        })
      } else {
        this.docTypeTree.rowData = []
      }
    },
    showDocTypeTree(seq) {
      const rows = this.rowData.filter(p => p.seq === seq)
      if (rows.length === 0) {
        return
      }
      const fileCategory = rows[0].fileCategory.toUpperCase()
      this.docTypeTree.rowData.forEach(item => {
        if (item.code.toUpperCase() === fileCategory) {
          item.checked = true
        } else {
          item.checked = false
        }
      })
      if (this.docTypeTree.gridApi) {
        this.docTypeTree.gridApi.refreshCells({ force: true })
      }
      this.docTypeTree.visible = true
    }
  }
}
</script>

<style scoped>
  .not-click {
    pointer-events: none;
  }
</style>
